import {
    Radio as AntdRadio,
    RadioProps as AntdRadioProps,
    RadioGroupProps as AntdRadioGroupProps,
    ConfigProvider,
} from 'antd';
import { useTheme } from '../../theme/ThemeContext';

export type RadioProps = AntdRadioProps & { 'data-test'?: string; };

export type RadioGroupProps = AntdRadioGroupProps & { 'data-test'?: string; };

const Radio: React.FC<RadioProps> & { Group: React.FC<RadioGroupProps>; Button: React.FC<RadioProps> } = ({
    ...props
}) => {
    return <AntdRadio {...props} />;
};

const RadioGroup: React.FC<RadioGroupProps> = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdRadio.Group {...props} data-test={props['data-test']} data-asper-radio-group/>
        </ConfigProvider>
    );
};

const RadioButton: React.FC<RadioProps> = ({ ...props }) => {
    const theme = useTheme();
    return (
        <ConfigProvider theme={theme}>
            <AntdRadio.Button {...props} data-test={props['data-test']} data-asper-radio/>
        </ConfigProvider>
    );
};

Radio.Group = RadioGroup;
Radio.Button = RadioButton;

export default Radio;
